import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormService } from 'app/services/form.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-existing-inn-name',
  templateUrl: './existing-inn-name.component.html',
  styleUrls: ['./existing-inn-name.component.scss']
})
export class ExistingInnNameComponent implements OnInit, OnDestroy {
  innSubmission!: string;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;


  constructor(private responsive: BreakpointObserver, private formService: FormService) { }

  ngOnInit(): void {
    this.innSubmission = this.currentForm.get('innSubmission')?.value;

    if(this.innSubmission && this.innSubmission == 'Yes') {
      this.currentForm.get('innSubmissionNumber')?.addValidators(Validators.required);
    }

    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  updateInnSubmission(value: string) {
    if(!value) {
      return;
    }
    
    this.innSubmission = value;
    
    if(!this.innSubmission || (this.innSubmission !== 'Yes' && this.innSubmission !== 'No')) {
      return;
    }
    
    this.formService.updateUsanFormValue('innSubmission', this.innSubmission);
    if(this.innSubmission && this.innSubmission == 'Yes') {
      this.currentForm.get('innSubmissionNumber')?.addValidators(Validators.required);
    } else {
      this.currentForm.get('innSubmissionNumber')?.removeValidators(Validators.required);
    }

  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }
  
  compareFn(value: string): boolean {
    return value == this.innSubmission;
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
